import React from "react";
import { FieldRendererProps } from "../types";
import { ErrorMessage } from "../styles";
import DecimalMonetario from "../../decimal";

export const DecimalFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, modo, getFieldValue, handleInputChange, handleBlur, errors,
}) => (
  <>
    <DecimalMonetario
      getFieldValue={getFieldValue}
      handleInputChange={handleInputChange}
      campo={{ nome: campo.nome, tipo: "decimal", required: campo.required, modo }}
      apenasLeitura={campo.apenasLeitura || false}
      onBlur={handleBlur}
    />
    {errors[campo.nome] && <ErrorMessage>{errors[campo.nome]}</ErrorMessage>}
  </>
);
